/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popReward.vue?vue&type=template&id=3285b864&scoped=true"
import script from "./popReward.vue?vue&type=script&lang=js"
export * from "./popReward.vue?vue&type=script&lang=js"
import style0 from "./popReward.vue?vue&type=style&index=0&id=3285b864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3285b864",
  null
  
)

export default component.exports